import React, { useState, useEffect } from 'react';
import { collection, getDocs, query, where } from 'firebase/firestore';
import { db } from '../firebase';
import './FloatingLautbilderButton.css';

function FloatingLautbilderButton({ selectedLauts = [] }) {
  const [isOpen, setIsOpen] = useState(false);
  const [lautbilderData, setLautbilderData] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (isOpen && selectedLauts.length > 0) {
      loadLautbilderForSelectedLauts();
    }
  }, [isOpen, selectedLauts]);

  const loadLautbilderForSelectedLauts = async () => {
    try {
      setLoading(true);
      setLautbilderData([]);
      setCurrentIndex(0);
      
      // Query lautbilder collection for any of the selected lauts
      const q = query(
        collection(db, 'lautbilder'), 
        where('laut', 'in', selectedLauts)
      );
      const querySnapshot = await getDocs(q);
      
      if (!querySnapshot.empty) {
        const data = querySnapshot.docs.map(doc => ({
          id: doc.id,
          ...doc.data()
        }));
        setLautbilderData(data);
      }
    } catch (error) {
      console.error('Error loading lautbilder:', error);
    } finally {
      setLoading(false);
    }
  };

  const toggleOpen = () => {
    setIsOpen(!isOpen);
  };

  const handlePrevious = () => {
    setCurrentIndex((prev) => (prev - 1 + lautbilderData.length) % lautbilderData.length);
  };

  const handleNext = () => {
    setCurrentIndex((prev) => (prev + 1) % lautbilderData.length);
  };

  // Don't show the button if no lauts are selected
  if (!selectedLauts || selectedLauts.length === 0) {
    return null;
  }

  const currentLautbild = lautbilderData[currentIndex];

  return (
    <>
      <div className="floating-lautbilder-button" onClick={toggleOpen}>
        <span className="floating-button-icon">L</span>
      </div>

      {isOpen && (
        <div className="lautbilder-box">
          <button className="close-button" onClick={() => setIsOpen(false)}>
            ×
          </button>
          
          {loading ? (
            <div className="loading-state">Lädt...</div>
          ) : currentLautbild ? (
            <div className="lautbilder-content">
              {lautbilderData.length > 1 && (
                <div className="navigation-controls">
                  <button className="nav-button" onClick={handlePrevious}>‹</button>
                  <span className="counter">{currentIndex + 1} / {lautbilderData.length}</span>
                  <button className="nav-button" onClick={handleNext}>›</button>
                </div>
              )}
              <img 
                src={currentLautbild.imageUrl} 
                alt={`Lautbild für ${currentLautbild.laut}`}
                className="lautbilder-image"
              />
              <h3 className="lautbilder-laut">{currentLautbild.laut}</h3>
            </div>
          ) : (
            <div className="no-data-state">
              {selectedLauts.length > 0 
                ? `Keine Lautbilder für "${selectedLauts.join(', ')}" gefunden`
                : 'Keine Laute ausgewählt'}
            </div>
          )}
        </div>
      )}
    </>
  );
}

export default FloatingLautbilderButton;